import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-order-summary',
  templateUrl: './sales-order-summary.component.html',
  styleUrls: ['./sales-order-summary.component.css']
})
export class SalesOrderSummaryComponent {
  displayedColumns: string[] = ['item', 'qty', 'unit_price', 'discount', 'discount_amount',
   'tax_code', 'tax_amount', 'amount'];
  dataSource : any = [{
    item:'0098123-Coca Cola Soft Drink 750', qty: '5', unit_price: '₹ 25,000.00', 
    discount: '10%', discount_amount: '₹ 2,500.00', tax_code: 'GST-18%', tax_amount: '₹ 2,000.00', amount:'₹ 23,800.00'
  }];
}
